<template>
  <input
    class="radio-color h-4 w-4 rounded-full bg-AkWhite border border-AkGreyscaleMediumLtGrey appearance-none md:h-6 md:w-6 md:checked:border-2"
    type="radio"
    :checked="checked === value"
    :value="value"
    v-bind="$attrs"
    v-on="inputListeners"
  />
</template>

<script>
export default {
  name: 'RadioColor',
  props: ['checked', 'value'],
  model: {
    prop: 'checked',
    event: 'input'
  },
  computed: {
    inputListeners: function () {
      return {
        ...this.$listeners,
        input: (event) => {
          // ;(this.$emit as Function)('input', event.target.value)
          this.$emit('input', this.value)
        },
        // for Microsoft Edge
        change: (event) => {
          // ;(this.$emit as Function)('input', event.target.value)
          this.$emit('input', this.value)
        }
      }
    }
  }
}
</script>
